import * as React from 'react';

import Grid from '@mui/material/Grid';

interface IProps {
  image: string;
  list: JSX.Element;
  title: string;
  reverse?: boolean;
  altDescription?: string;
}

interface IDefaultProps {
  reverse: boolean;
}

class FeatureList extends React.PureComponent<IProps> {
  private static readonly defaultProps: IDefaultProps = {
    reverse: false,
  };

  public render(): JSX.Element {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let { image, list, title, reverse, altDescription } = this.props;

    return (
      <Grid
        container={true}
        spacing={3}
        justifyContent={'center'}
        direction={reverse ? 'row-reverse' : 'row'}
        className="home-page__feature-list-container"
      >
        <Grid item={true} sm={5} lg={4} className="home-page__feature-list-image-container">
          <img src={image} className="home-page__feature-list-image" alt={altDescription} />
        </Grid>
        <Grid item={true} xs={10} sm={5} lg={4} className="home-page__feature-list-text-container">
          <h3 className="home-page__feature-list-title">{title}</h3>
          {list}
        </Grid>
      </Grid>
    );
  }
}

export { FeatureList };
